import { EditorContent } from "@tiptap/react";
import { type RefObject, useMemo } from "react";

import { type Assignment } from "@/types/models/Assignment.interface";
import { type GenerationGeniusAPIResponse } from "@/types/models/GenerationGenius.interface";
import useGetUserProperties from "@/users/v3/useGetUserProperties";
import PanelHeader from "@/view/PanelHeader";
import { type IGeniusButtonEventProperties } from "@/view/UnlevelledContent/UnlevelledContentActivityPanel/UnlevelledContentActivityPanel.constant";
import { formatGeniusActivityPanelContent } from "@/view/UnlevelledContent/utils";
import useGeniusEditor from "@/view/UnlevelledContent/utils/useGeniusEditor/useGeniusEditor";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import {
  drawerContainerCss,
  titleCss,
} from "./UnlevelledContentVocabularyContainer.style";

interface UnlevelledContentVocabularyContainerProps {
  backButtonEventProperties: IGeniusButtonEventProperties;
  closeButtonEventProperties: IGeniusButtonEventProperties;
  onClickBackButton: () => void;
  onClickCloseButton: () => void;
  shouldFocusCloseButtonRef: RefObject<boolean>;
  contentData: GenerationGeniusAPIResponse;
}

export const UnlevelledContentVocabularyContainer = ({
  backButtonEventProperties,
  closeButtonEventProperties,
  onClickBackButton,
  shouldFocusCloseButtonRef,
  contentData,
  onClickCloseButton,
}: UnlevelledContentVocabularyContainerProps) => {
  const { updatedAssignment } = useAssignmentReducerContext() as {
    updatedAssignment: Assignment;
  };

  const { isStudent } = useGetUserProperties() || {};

  const { hide_generation_genius_vocab_definitions: hideVocabDefinitions } =
    updatedAssignment.assignment_config;

  const shouldHideVocabDefinitions = Boolean(isStudent && hideVocabDefinitions);

  const { vocabulary } = useMemo(
    () =>
      formatGeniusActivityPanelContent(contentData, shouldHideVocabDefinitions),
    [contentData.vocabulary, shouldHideVocabDefinitions],
  );
  const editor = useGeniusEditor({ content: vocabulary });

  return (
    <>
      <PanelHeader
        onClickBackButton={onClickBackButton}
        onClickCloseButton={onClickCloseButton}
        backButtonEventProperties={backButtonEventProperties}
        closeButtonEventProperties={closeButtonEventProperties}
        shouldFocusCloseButtonRef={shouldFocusCloseButtonRef}
      >
        <h2 css={titleCss}>Vocabulary</h2>
      </PanelHeader>

      <div css={drawerContainerCss}>
        <EditorContent editor={editor} />
      </div>
    </>
  );
};

export default UnlevelledContentVocabularyContainer;
